import harmlistLogo from '@podus/ui/logo-icons/harmlist.png';
import irisLogo from '@podus/ui/logo-icons/iris.png';
import justiceClockLogo from '@podus/ui/logo-icons/justice-clock.png';
import openJusticeLogo from '@podus/ui/logo-icons/open-justice.png';
import podusAidLogo from '@podus/ui/logo-icons/podus-aid.png';
import podusAiLogo from '@podus/ui/logo-icons/podus-ai.png';
import podusAppointmentLogo from '@podus/ui/logo-icons/podus-appointment.png';
import podusContractLogo from '@podus/ui/logo-icons/podus-contract.png';
import podusMultidoorLogo from '@podus/ui/logo-icons/podus-multidoor.png';
import yourcheckaLogo from '@podus/ui/logo-icons/yourcheaka.png';

/**
 * Product marks, by slug.
 *
 * These are brand assets the app ships, not content: the CMS has no logo field
 * on a project at all, and the one on a product holds a file name rather than a
 * picture. They used to be reached through the bundled project and product
 * lists, so emptying those took the logos with them.
 */
export const PRODUCT_MARKS: Record<string, string> = {
    'podus-ai': podusAiLogo,
    'podus-contract': podusContractLogo,
    'podus-appointment': podusAppointmentLogo,
    'podus-legal-aid': podusAidLogo,
    'podus-aid': podusAidLogo,
    'podus-checker': yourcheckaLogo,
    'yourchecka': yourcheckaLogo,
    'podus-multidoor-court': podusMultidoorLogo,
    'podus-multidoor': podusMultidoorLogo,
    'justice-clock': justiceClockLogo,
    'judicial-accountability': openJusticeLogo,
    'open-justice': openJusticeLogo,
    'iris': irisLogo,
    'harmlist': harmlistLogo,
};

/** The mark for a slug, or nothing rather than another product's. */
export const productMark = (slug: string): string => PRODUCT_MARKS[slug] ?? '';
